import React from "react";
import ProceedIcon from "../../assets/images/Delete.svg";
import { gtmPush } from "../../analytics/useGtmPageview.tsx";

const DeleteButton = ({ onClick, text, type = "button", disabled = false }) => {
  const handleClick = (e) => {
    // ✅ Push event to GTM
    gtmPush("button_click", {
      elementId: "delete-button",
      button_text: text,
      page_path: window.location.pathname + window.location.search,
    });

    // ✅ Call the parent’s onClick if provided
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <button
      className="step-btn btn-delete"
      onClick={handleClick}
      type={type}
      disabled={disabled}
    >
      <img src={ProceedIcon} alt="" />
      {text}
    </button>
  );
};

export default DeleteButton;
